import { withBaseSelect } from "shared/HOC";

// pipes
import { titleCasePipe } from "shared/pipes";

const buildRole = (role) => {
    return { label: titleCasePipe.transform(role), value: role };
}
const roles = ['buyer', 'stylist', 'packer', 'quality_check', 'sender', 'customer_support', 'return_manager', 'admin']
    .map((role) => buildRole(role));

const SelectRole = withBaseSelect(roles);
export default SelectRole;
